// @flow

import { get, trim } from "lodash";
import type { RaceCardBettingInterest } from "@tvg/types/Race";

export type TrackLocation = {
  country: string,
  state: string
};

export type TrackHighlighted = {
  description: string
};

export const getTrackDescription = (
  trackName: string,
  trackLocation: TrackLocation,
  highlighted?: ?TrackHighlighted
) => {
  const trackDetails = trackName.split("-");
  const country = get(trackLocation, "country");
  const isNationalRace = country === "USA";

  if (!isNationalRace && trackDetails.length > 1) {
    trackDetails.shift();
  }

  const name = trackDetails.join("-");
  const city = isNationalRace ? get(trackLocation, "state") : country;
  const highlightedDescription =
    get(highlighted, "style") === "Highlighted" &&
    get(highlighted, "description");

  return highlightedDescription
    ? {
        trackTitle: highlightedDescription,
        trackCity: trim(city),
        trackSubtitle: trim(name)
      }
    : {
        trackTitle: trim(name),
        trackCity: trim(city),
        trackSubtitle: null
      };
};

export const getNumberSuffix = (number: number) => {
  const suffix =
    {
      "1": "st",
      "2": "nd",
      "3": "rd"
    }[number.toString()] || "th";

  return suffix;
};

export const getWPSLabel = (position: number) => {
  const label =
    {
      "0": "Win",
      "1": "Place",
      "2": "Show"
    }[position.toString()] || "Across the board";

  return label;
};

export const doesSilkLoads = (
  bettingInterests: RaceCardBettingInterest[][],
  isRacecard: boolean = false
): Promise<boolean> => {
  if (get(bettingInterests, "length", 0)) {
    let firstRunnerList = get(bettingInterests, "[0].runners[0]", {});
    let silkUrl = get(firstRunnerList, "timeform.silkUrlSvg", "");

    if (isRacecard) {
      firstRunnerList = get(bettingInterests, "[0].[0].runners", {});
      silkUrl = get(firstRunnerList, "[0].timeform.silkUrlSvg", "");
    }

    if (silkUrl) {
      return new Promise((resolve) => {
        const img = new Image();
        // eslint-disable-next-line
        img.onerror = img.onabort = () => {
          resolve(false);
        };
        img.onload = () => {
          resolve(true);
        };
        img.src = silkUrl;
      });
    }
  }
  return Promise.resolve(false);
};

export default { getTrackDescription, getNumberSuffix, getWPSLabel };
